import { render, staticRenderFns } from "./bullIndividualSemenCollection.vue?vue&type=template&id=148f4746&scoped=true&"
import script from "./bullIndividualSemenCollection.vue?vue&type=script&lang=js&"
export * from "./bullIndividualSemenCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f4746",
  null
  
)

export default component.exports